import { render, staticRenderFns } from "./AmbassadorPage.vue?vue&type=template&id=39befd48&"
import script from "./AmbassadorPage.vue?vue&type=script&lang=js&"
export * from "./AmbassadorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports